module.exports = __webpack_public_path__ + "media/fr-8b87229c.mp4";